import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
	steps?: string[];
	step?: number;
};

const SideLogo: React.FC<Props> = ({ steps, step }: Props) => {
    const { t } = useTranslation();

	return (
		<div className="kyc-steps__wrapper">
			<div className="kyc-steps__logo" />
			{steps &&
				<ol className="kyc-steps__list">
					{steps.map((name:any,index:number)=>(<li key={index} className={index+1==step?"current":(step && step>index+1?"completed":"")}>{t(name)}</li>))}
				</ol>}
		</div>

	);
};

export default SideLogo;
